import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';

const styles = () => ({
  root: {
    display: 'flex',
  },
  form: {
  },
});

function HouseholdInfo({ classes, selectedEscalatedHousehold, ...rest }) {
  const getContent = () => (
    <MetaFormInline
      resource={selectedEscalatedHousehold}
      className={classes.form}
      readonly
    />
  );
  return (
    <div className={classNames(classes.root)} {...rest}>
      { selectedEscalatedHousehold.id() && getContent() }
    </div>
  );
}
HouseholdInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedEscalatedHousehold: PropTypes.object.isRequired,
};

export default withStyles(styles)(HouseholdInfo);
